import React from "react";
import "./feastCoach.css";
import PlanForm from "./PlansForm";
import PlanFormMobile from "./mobile/PlanFormMobile";

const cdnUrl = "https://cdn.fitimg.in/cdn";

const fitCoachList = [
    {icon: "icon-run", description: "AI-led Personalized Fitness Routines"},
    {icon: "icon-video", description: "Smart instruction videos in HD"},
    {icon: "icon-Abs", description: "Dynamic workout recommendations"},
    {icon: "icon-target_ic", description: "Adaptive and self-evolutionary"}
];

const plans = [
    [
        {
            plan_master_id: 548,
            product_type: 12,
            product_name: "FP PRO",
            tax_applicable: false,
            tax_applicable_amount: 28,
            service_tax: 3603.25,
            membership_price: 12868.75,
            actual_amount: 16472,
            duration: 3,
            selling_amount: 8236,
            membership_validity:
                "3 Months FP PRO (FITPASS+FITCOACH+FITFEAST) Membership with FITPASS Co-Branded Smartwatch",
        }
    ],[
        {
            plan_master_id: 490,
            product_type: 1,
            product_name: "FITPASS",
            tax_applicable: false,
            tax_applicable_amount: 28,
            service_tax: 349.78,
            membership_price: 1599,
            actual_amount: 2046.78,
            duration: 1,
            selling_amount: 1599,
            membership_validity: "1 Month FITPASS Premium Membership Unlimited* access to all fitness centers in the network",
        }
    ]
];

export default class StayFit extends React.Component {
    openModal = () => {
        this.setState({openModal: true});
    };
    closeModal = () => {
        this.setState({openModal: false});
    };

    onChangePlan = (index) => {
        this.setState({basicPlanIndex: index});
    };

    render() {
        let {isMobile} = this.props;
        let {
            openModal,
            selectedPlanIndex = 0,
            isAgree = true,
            basicPlanIndex = 0,
        } = this.state || {};
        let currentPlan = plans[selectedPlanIndex];
        let planProps = {
            onChangePlan: this.onChangePlan,
            plans: plans[basicPlanIndex],
            basicPlanIndex,
            closeModal: this.closeModal,
        };
        let planFormView =
            plans && isMobile ? (
                <PlanFormMobile {...planProps} />
            ) : (
                <PlanForm {...planProps} />
            );
        let product_type = currentPlan.product_type;
        if (openModal) {
            return planFormView;
        }
        return (
            <div
                className={"fullWidth"}
                // head={<>
                //     {/* <link rel="stylesheet" href={`${cdnUrl}/css/partners.min.css`} />
                //     <link rel="stylesheet" href={`${cdnUrl}/css/fitcoach.min.css`} />
                //     <title>Stay fit during corona virus</title>
                //     <link rel="canonical" href="https://fitpass.co.in/stay-fit-avoid-coronavirus" />
                //     <meta name="og:url" content="https://fitpass.co.in/stay-fit-avoid-coronavirus" />
                //     <meta name="description" content="Advertise wide range of fitness classes, workouts through FITPASS. Generate leads, increase revenue by partnering with FITPASS." />
                //     <meta name="twitter:description" content="Advertise wide range of fitness classes, workouts through FITPASS. Generate leads, increase revenue by partnering with FITPASS." />
                //     <meta name="og:description" content="Advertise wide range of fitness classes, workouts through FITPASS. Generate leads, increase revenue by partnering with FITPASS." />
                //     <meta name="og:image:alt" content="Stay fit during corona virus" />
                //     <meta name="og:title" content="Stay fit during corona virus" />
                //     <meta name="twitter:title" content="Stay fit during corona virus" />
                //     <meta name="keyword" content="Fitness workouts Delhi,Fitness Classes Delhi, Fitness Classes Noida, Fitness Classes Gurugram, Fitness Classes India, Best Fitness Classes, Fitpass.co.in" /> */}
                // </>}
                // isMobile={isMobile}
            >
                <div style={{paddingLeft: 0}} className={"bannerContainer"}>
                    {isMobile ? (
                        <>
                            <img width={"100%"} src={`/images/fc_ff_mob_banner.png`}/>

                            <ListContainer
                                isMobile
                                id={"fitcoach"}
                                title={"WHAT WILL YOU GET?"}
                                description={""}
                                data={fitCoachList}
                            />
                            <div className={"MobileproductDetailsContent bgWhite"}>
                                <img
                                    width={"100px"}
                                    src={`/images/mobile_product_details.png`}
                                    alt="mobileProductDetails"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                style={{
                                    backgroundImage: `url("/images/desktop_banner_web.png")`,
                                }}
                                className={"partnerBannerContent bgWhite"}
                            ></div>
                        </>
                    )}
                </div>
                {isMobile ? (
                    <></>
                ) : (
                    <>
                        <div className={"alignCenter bgWhite pb_30 flex column"}>
                            <ListContainer
                                title={"WHAT WILL YOU GET?"}
                                id={"fitcoach"}
                                // description={"YOUR SMART FITNESS COACH"}
                                // data={fitCoachList}
                                // image={"/images/fitcoach_ic.png"}
                                // listHeading={"Workout at home or any other safe place at your convenience"}
                            />

                            <div className={"productDetailsContent bgWhite"}>
                                <img
                                    width={"100px"}
                                    src={`/images/desktop_product_details.png`}
                                    alt="fitpassAppstore"
                                />
                            </div>
                            <div
                                onClick={this.openModal}
                                className="getFitButton f4 link c2 gothamBold"
                            >
                                GET FIT NOW
                            </div>
                        </div>
                    </>
                )}

                {isMobile && (
                    <div
                        style={{position: "sticky", bottom: 30}}
                        onClick={this.openModal}
                        className="getFitButton textCenter c2 gothamBold"
                    >
                        GET FIT NOW{" "}
                    </div>
                )}
                {isMobile ? (
                    <div
                        className={"corporateFooterContainer flex column alignCenter c2"}
                    >
                        <span className={"f4 bold"}>Get the FITPASS App</span>
                        <div className={"flex alignCenter"}>
                            <a className={"mt_12"} target="_blank"
                               href="https://itunes.apple.com/in/app/fitpass/id1049745078?mt=8">
                                <img
                                    width={"100px"}
                                    src={`${cdnUrl}/images/app_store_ic.png`}
                                    alt="fitpassAppstore"
                                />
                            </a>
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.india.fitpass">
                                <img
                                    width={"100px"}
                                    className="ml_12 mt_12"
                                    alt="fitpassPlaystore"
                                    src={`${cdnUrl}/images/play_store_ic.png`}
                                />
                            </a>
                        </div>
                        <div className={"f8"}>
                            {" "}
                            © 2015-2023 fitpass.co.in | All Rights Reserved
                        </div>
                    </div>
                ) : (
                    <div
                        className={
                            "corporateFooterContainer flex spaceBetween alignCenter c2"
                        }
                    >
                        <div> © 2015-2023 fitpass.co.in | All Rights Reserved</div>
                        <div className={"flex alignCenter"}>
                            <span>Get the FITPASS App</span>
                            <a
                                className={"ml_12"}
                                target="_blank"
                                href="https://itunes.apple.com/in/app/fitpass/id1049745078?mt=8"
                            >
                                <img
                                    src={`${cdnUrl}/images/app_store_ic.png`}
                                    alt="fitpassAppstore"
                                />
                            </a>
                            <a
                                target="_blank"
                                href="https://play.google.com/store/apps/details?id=com.india.fitpass"
                            >
                                <img
                                    className="ml_12"
                                    src={`${cdnUrl}/images/play_store_ic.png`}
                                    alt="fitpassPlaystore"
                                />
                            </a>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const BannerButton = ({title, href, heading, backgroundClass, isMobile}) => {
    return isMobile ? (
        <a href={href} className={"textCenter noDecoration"}>
            <span className={`c1 f7`}>{heading}</span>
            <div className={`${backgroundClass} mt_12 gothamBold c2 bannerButton`}>
                {title}
            </div>
        </a>
    ) : (
        <a href={href} className={"textCenter noDecoration"}>
            <span className={`c1 f4`}>{heading}</span>
            <div className={`${backgroundClass} mt_12 gothamBold f2 c2 bannerButton`}>
                {title}
            </div>
        </a>
    );
};

const ListContainer = ({
                           data,
                           id,
                           image,
                           color,
                           title,
                           description,
                           listHeading,
                           isMobile,
                       }) => {
    let backgroundColor = title === "FITCOACH" ? "#F4F9FF" : "#fff";
    return isMobile ? (
        <div id={id} style={{backgroundColor}} className="fitFeastListContainer">
            <h2 className="headingText listHeading c1">WHAT WILL YOU GET?</h2>
        </div>
    ) : (
        <div
            id={id}
            style={{backgroundColor}}
            className="fitFeastListContainer fullWidth"
        >
            <div className="flex column alignCenter">
                <h2 className="textCenter f2 c1 gothamBold">{title}</h2>
                <div className={"bannerGradient"}></div>
            </div>
        </div>
    );
};
